export const fetchUserQuery = () => {
  const query = `
    query{
      fetchUser{
        username
        id
        firstName
        lastName
        email
        phoneNumber
        userId
        teamMember{
          id
          isAdmin
          customerAccount{
            id
          },
          role,
          propertyIds
        }
      }
    }
  `;
  return query;
}

export const LoginMutation = (username, password) => {
    const mutation = `
        mutation {
            tokenAuth(username: "${username}", password: "${password}") {
            success,
            errors,
            token,
            refreshToken,
            unarchiving,
            user {
                id,
                pk,
                username,
                firstName,
                lastName,
                email
                phoneNumber
            }
            }
        }
    `;
  return mutation;
}


export const RegisterMutation = (email, username, phoneNumber, password1, password2, registrationSource) => {
  const mutation = `
        mutation {
            register(
            email: "${email}",
            username: "${username}",
            password1: "${password1}",
            password2: "${password2}",
            phoneNumber: "${phoneNumber}",
            registrationSource: "${registrationSource}",
            ) {
            success,
            errors
            }
        }
  `;
  return mutation
}

export const SendPasswordResetMutation = (username) => {
  const mutation = `
        mutation {
            sendPasswordResetEmail(
            username: "${username}"
            ) {
            success,
            errors
            }
        }
    `;
  return mutation
}

export const sendForgotUsernameMutation = (email) => {
  const mutation = `
    mutation {
      sendForgotUsernameEmail(
        email: "${email}"
      ) {
        success,
        errors
      }
    }
  `
  return mutation;
}

export const UsernameCheckQuery = (username) => {
  const query = `
      query {
          users(username: "${username}"){
          edges {
              node {
              username,
              email,
              }
          }
          }
      }
      `;
  return query
}

export const PasswordResetMutation = (token, newPassword1, newPassword2) => {
  const mutation = `
  mutation {
      passwordReset(
        token: "${token}",
        newPassword1: "${newPassword1}",
        newPassword2: "${newPassword2}"
      ) {
        success,
        errors
      }
    }
`;
  return mutation
}

export const PasswordChangeMutation = (payload) => {
  const mutation = `
    mutation {
      passwordChange(
        oldPassword: "${payload.oldPassword}",
        newPassword1: "${payload.newPassword1}",
        newPassword2: "${payload.newPassword2}"
      ) {
        success,
        errors
      }
    }
  `;
  return mutation
}

export const ActivateAccountMutation = (token) => {
  const mutation = `
  mutation {
    verifyAccount(
      token:"${token}",
    ) {
      success, errors
    }
  }
  `;
  return mutation
}

//Returns the user ID as a string. Remember to convert it to int before storing
export const GetUserIdQuery = (username) => {
  const query = `
  query{
    getUserId(username:"${username}"){
      id
    }
  }
  `;
  return query
}

export const verifyTokenMutation = (token) => {
  const mutation = `
  mutation {
    verifyToken(
      token:"${token}"
    ) {
      success,
      errors,
      payload
    }
  }
  `;
  return mutation
}

export const renewAccessTokenMutation = (refreshToken) => {
  const mutation = `
  mutation {
    refreshToken(refreshToken: ${JSON.stringify(refreshToken)}) {
      token
      refreshToken
    }
  }
  `;
  return mutation;
}
